import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"calendar\"><g fill-rule=\"evenodd\"><path d=\"M3 8h14v9H3z\" opacity=\".1\" /><path fill-rule=\"nonzero\" d=\"M7 1v2h6V1h1v2h2a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2V1h1ZM3 8v8a1 1 0 0 0 .883.993L4 17h12a1 1 0 0 0 .993-.883L17 16V8H3Zm0-1h14V5a1 1 0 0 0-.883-.993L16 4h-2v2h-1V4H7v2H6V4H4a1 1 0 0 0-.993.883L3 5v2Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol